import React, { useEffect, useState } from "react";
import { Container, Spinner, Alert } from "react-bootstrap";
import axios from "axios";
import { useLoader } from "../loader/LoaderContext";

const PrivacyPolicy = () => {
  const [privacypolicy, setPrivacypolicy] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { showLoader, hideLoader } = useLoader();

  useEffect(() => {
    const fetchprivacypolicy = async () => {
      const token = localStorage.getItem("admin_token");
      try {
        showLoader();
        const response = await axios.get(
          "https://toptennis.io/api/user/policyText",
          {
            headers: {
              authorization: `Bearer ${token}`,
            },
          }
        );
        setPrivacypolicy(response.data[0].content);
      } catch (err) {
        setError("Failed to load privacypolicy and Conditions.");
      } finally {
        setLoading(false);
        hideLoader();
      }
    };

    fetchprivacypolicy();
  }, []);

  return (
    <Container className="pt-4 px-3 px-md-5">
      <h2 className="mb-4">Privacy Policy</h2>
      {loading && <Spinner animation="border" />}
      {error && <Alert variant="danger">{error}</Alert>}
      {!loading && !error && (
        <div dangerouslySetInnerHTML={{ __html: privacypolicy.replace(/\n/g, '<br/>') }} />
      )}
    </Container>
  );
};

export default PrivacyPolicy;
